import React, {
  Dispatch,
  FC,
  SetStateAction,
  useState,
  useEffect,
} from 'react';
import { SmallToggle } from './Small';
import { NormalToggle } from './Normal';

export interface ToggleProps {
  toggleSize?: 'small' | 'normal';
  className?: string;
  label?: string;
  onChange: Dispatch<SetStateAction<Boolean>>;
  toggled?: boolean;
  name?: string;
  isValid?: boolean;
  errorMessage?: string;
}

export const Toggle: FC<ToggleProps> = ({
  toggleSize = 'normal',
  className,
  label,
  onChange,
  toggled = false,
  name,
  isValid,
  errorMessage,
  ...rest
}: ToggleProps) => {
  const [enabled, setEnabled] = useState(toggled);
  useEffect(() => setEnabled(toggled), [toggled]);

  const renderSmallToggle = toggleSize === 'small' && (
    <SmallToggle
      label={label}
      className={className || ''}
      onChange={onChange}
      toggled={enabled}
      name={name}
      isValid={isValid}
      errorMessage={errorMessage}
      {...rest}
    />
  );

  const renderNormalToggle = toggleSize === 'normal' && (
    <NormalToggle
      label={label}
      className={className || ''}
      onChange={onChange}
      toggled={enabled}
      name={name}
      isValid={isValid}
      errorMessage={errorMessage}
      {...rest}
    />
  );
  return (
    <>
      {renderSmallToggle}
      {renderNormalToggle}
    </>
  );
};
